export const GET_ENTITY_EXPENSE = "GET_ENTITY_EXPENSE";
export const GET_ALL_ENTITY_EXPENSES = "GET_ALL_ENTITY_EXPENSES";
export const SET_ENTITY_EXPENSES_LOADING = "SET_ENTITY_EXPENSES_LOADING";
export const GET_ERRORS = "GET_ERRORS";
export const SET_SELECT_CORPORATE_ENTITIES = "SET_SELECT_CORPORATE_ENTITIES";
export const SET_SELECT_CORPORATE_EXPENSES = "SET_SELECT_CORPORATE_EXPENSES";
export const SET_SELECT_USERS = "SET_SELECT_USERS";
